export const getUserStatus = (state) => state.loginReducers.userStatus;
